namespace appn.views.data.map {

    class InitArgs {
        dFilter: string = emptyString;
        showDataTable: boolean = false;
        userLatLon: string = emptyString;
        userList: Array<AppnSelectListItem> = [];
        dataMapEntries: string = emptyString;
    }

    let _initArgs: InitArgs;

    let _map: L.Map;
    let _entrieslayers: Array<L.Layer> = [];
    let _pageNum = 1;
    let _totalEntries = 0;
    let _resultsWithoutGPS = 0;
    let _searchValue: string = appn.emptyString;

    export function init(args: InitArgs): void {
        _initArgs = args;

        appn.dataView.init();

        prependSearchAndFilters();

        if (_initArgs.showDataTable)
            setupViewParameters();

        addEvents();
        appn.popover.init();
    }

    appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function(channel: string, data: any) {
        if (!_map)
            return;

        _map.invalidateSize();
    });

    function setupViewParameters(): void {
        appn.dateFilter.init(_initArgs.dFilter);

        // Resize map div to take up all available height
        const availableHeight = Number($('#content').height()) - Number($('#dataToolbar').height()) - Number($('#pagingToolbar').height()) - 30;

        if (!isNaN(availableHeight))
            $('#map').height(availableHeight);

        _map = appn.ui.mapInit('map', 0, 0, 11, false);

        // Check querystring for inputs, assume all set by server
        const screenKey = ($ as any).getUrlVar('screenKey');
        if (screenKey !== appn.emptyString)
            getEntries(true);

        $('#PageSize').change(function() {
            getEntries(false);
        });
        $('#GoPrevious').click(function() {
            if ($('#GoPrevious').hasClass('paginate_enabled_previous')) {
                _pageNum--;
                getEntries(false);
            }
        });
        $('#GoNext').click(function() {
            if ($('#GoNext').hasClass('paginate_enabled_next')) {
                _pageNum++;
                getEntries(false);
            }
        });
    }

    function getEntries(shouldUseEntryId: boolean): void {
        appn.dialog.showLoading();
        const screenKey = $('#SelectedScreenKey').val();
        const version = $('#SelectedVersionNo').val();
        const pageSize = $('#PageSize').val();
        const userId = $('#ByUser').val();

        let entryId: any = null;

        // As soon as the user changes filter settings, we set the entryId to null so that we can ignore it.
        if (shouldUseEntryId === true)
            entryId = $('#EntryId').val();
        else
            $('#EntryId').val(appn.emptyString);

        const appnDateFilterValue = appn.dateFilter.getStateOrDefault();
        const $form = $('form#appnForm');

        if ($form.valid())
            appn.ajax.post({
                url: _initArgs.dataMapEntries,
                dataType: 'json',
                data: {
                    screenKey: screenKey,
                    version: version,
                    dfilter: appnDateFilterValue.type,
                    fromDate: appnDateFilterValue.fromDate,
                    toDate: appnDateFilterValue.toDate,
                    pageSize: pageSize,
                    pageNum: _pageNum - 1,
                    entryId: entryId,
                    searchId: encodeURIComponent(_searchValue),
                    userId: userId
                },
                done: function(data: IDTDataResult) {
                    processResult(data);
                },
                fail: function(jqXHR: JQueryXHR, textStatus: string, errorThrown: any) {
                    appn.toast.notify(toast.Type.error, T('Failed to fetch map data.'));
                }
            });
    }

    function processResult(data: IDTDataResult): void {
        // Remove the existing markers ready for the new set being drawn
        removeMarkers();

        _resultsWithoutGPS = 0;

        const userLatLon = _initArgs.userLatLon.split(',');
        const userLat: number = userLatLon[0] as any;
        const userLon: number = userLatLon[1] as any;

        let lastEntryLatLng = new L.LatLng(userLat, userLon); // Default to user country
        const markers = L.markerClusterGroup();
        // Process the received entries onto the map
        for (let i = 0; i < data.aaData.length; i++) {
            const lat: number = data.aaData[i][3] as any;
            const lon: number = data.aaData[i][4] as any;
            if (lat !== 0 && lon !== 0) { // Exclude 0,0 lat/lon since this is a fail to capture GPS on device
                const entriesll = new L.LatLng(lat, lon, 0);
                const entriesmark = new L.Marker(entriesll);
                markers.addLayer(entriesmark);

                const icon = L.divIcon({ // Some styles need to be defined inline as they depend on conditional styling of the column
                    html: '<div class="appn-mapPin"></div>' +
                        '<div class="appn-mapShadow"></div>'
                });

                (entriesmark as any).data = data.aaData[i];
                (entriesmark as any).data.splice(3, 2); // Remove lat/lon values
                entriesmark.setIcon(icon);
                entriesmark.on('click', markerClick);

                lastEntryLatLng = entriesll;
            } else
                _resultsWithoutGPS++;
        }

        _map.addLayer(markers);
        _entrieslayers.push(markers);

        updateUI(data);

        _map.setView(lastEntryLatLng, 11);

        // Remove disabled attribute if it is on the child
        const entryDiv = $('#entryData');
        entryDiv.empty();

        const columns = data.sColumns.split(',');

        for (let i = 0; i < columns.length; i++)
            entryDiv.append('<tr><td>' + columns[i] + '</td><td class="displayText"></td></tr>');

        appn.saveMeState.init(function() {
                getEntries(false);
            },
            function() {
                getEntries(false);
            },
            '.map-filters');

        select.init();

        // If there is only one marker, select it by default
        if (data.aaData.length === 1)
            markerClick(_entrieslayers[0]);

        appn.dialog.hideLoading();

        // Click event handler for viewing media files
        $('td').on('click', 'a#viewMedia', function(event) {
            event.preventDefault();
            appn.dialog.viewMediaFromElement($(this));
        });

    }

    function updateUI(data: IDTDataResult): void {
        const pageSize: number = $('#PageSize').val() as any;
        _totalEntries = data.iTotalDisplayRecords;

        let totalText = appn.strings.noResultsFound;
        if (_totalEntries > 0) {
            totalText = T('Showing {0} to {1} of {2} entries',
                (pageSize * _pageNum) - pageSize + 1, Math.min(pageSize * _pageNum, _totalEntries), _totalEntries);
            if (_resultsWithoutGPS > 0)
                totalText += '<br><i>(' + T('Cannot show {0} entries due to missing GPS location', _resultsWithoutGPS) + ')</i>';
        }

        $('#TotalsText').html(totalText);

        if ((pageSize * _pageNum) < _totalEntries) {
            $('#GoNext').removeClass('paginate_disabled_next');
            $('#GoNext').addClass('paginate_enabled_next');
        } else {
            $('#GoNext').removeClass('paginate_enabled_next');
            $('#GoNext').addClass('paginate_disabled_next');
        }
        if (_pageNum > 1) {
            $('#GoPrevious').removeClass('paginate_disabled_previous');
            $('#GoPrevious').addClass('paginate_enabled_previous');
        } else {
            $('#GoPrevious').removeClass('paginate_enabled_previous');
            $('#GoPrevious').addClass('paginate_disabled_previous');
        }
    }

    function markerClick(event: any): void {
        if (event !== undefined) {
            // If a marker is clicked, display the details from it
            const entryDivs = $('.displayText');

            // Check if marker was click from view, or was fired from js
            const data = (!event.target ? event.data : event.target.data);
            if (data === undefined)  // The user may click while the map is still loading.
                return;

            for (let i = 1; i < data.length; i++)
                $(entryDivs[i - 1]).html(data[i]);

            appn.dialog.singleEntryExport.init();
        }
    }

    function removeMarkers(): void {
        // Remove each 'layer' with a marker in it.
        for (let i = 0; i < _entrieslayers.length; i++)
            _map.removeLayer(_entrieslayers[i]);

        _entrieslayers = [];
    }

    function prependSearchAndFilters(): void {
        // Get the element to inject this box into
        const filtersContainer = $('.map-filters');

        // Add the search box and filters
        if (_initArgs.showDataTable) {
            if (_initArgs.userList.length > 0)
                $(elementBuilder.buildAppnSelect(_initArgs.userList, 'ByUser', 'saveMeState select2-noinit')).appendTo(filtersContainer);

            $(generateSeachInput()).appendTo(filtersContainer);
        }

        appn.sideFilterAndContent.appendShowButton(filtersContainer);
        appn.saveMeState.init();

        select.init({ selector: '#ByUser', minimumResultsForSearch: '25' }); // Start displaying 'search' at 25 items
    }

    function addEvents(): void {
        // Since this is a custom search we need to also reset the page number
        $('#SearchId').off().on('keydown', function(event) {
            if (!(event.keyCode === 13) || !event.target || !((event.target as any).type === 'search'))
                return;

            event.preventDefault();
            _searchValue = $('#SearchId').val() as string;
            $('#SearchId').blur();
            _pageNum = 1;

            getEntries(false);
        });

        // Make sure that the getEntries() function fires when we select a user
        $('#ByUser').off().on('change', function(event) {
            event.preventDefault();
            getEntries(false);
        });
    }

    function generateSeachInput(): string {
        return `<input placeholder="${T('Hit Enter to Search')}" type="search" class="form-control form-control-sm" id="SearchId" name="SearchId" aria-controls="DataTables_Table_0" title="${T('Filter results where the selected forms <b>Answers</b> start with a keyword typed in here.')}">`;
    }

}
